export const FILTER_GROUP_ID_PREFIX = 'filterGroup-';
export const FILTER_ITEM_ID_PREFIX = 'filterItem-';